import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BackendPaths } from '@common/backend-paths';
import { DataService } from '@data/data.service';
import { NotificationService } from '@notification/notification.service';
import { DeleteType } from '../../order-basic';
import { choice, firstNonEmpty } from '@util/utils';

export interface DeleteDialogData {
  fromTrash: boolean;
  type: string;
  name?: string;
  order?: any;
  orderId?: any;
  documentId?: any;
}

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
})
export class DeleteDialogComponent implements OnInit {
  title = 'Möchten Sie wirklich den Auftrag löschen ?';
  name = '';
  orderData: any = null;

  constructor(
    public dialogRef: MatDialogRef<DeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: DeleteDialogData,
    private dataService: DataService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    if (this.dialogData.type === DeleteType.DOCUMENT) {
      this.title = 'Möchten Sie wirklich das Dokument löschen ?';
      if (this.dialogData.name) {
        this.name = this.dialogData.name;
      }
    }
    this.orderData = this.dialogData.order;
  }

  doNotDelete() {
    this.dialogRef.close();
  }

  doDelete() {
    let orderId: any, url = '';
    const d = this.dialogData;

    if (d.type === DeleteType.DOCUMENT) {
      orderId = d.documentId;
      const postData = {
        op: 'deletedocument',
        order_id: d.orderId,
        document_id: d.documentId
      };

      const docUrl = '/montage/documents/' + d.orderId + '/' + d.documentId;
      url = d.fromTrash ? '/montage/trash/documents/' : docUrl;

      const ns = this.notificationService;

      this.dataService.post(url, postData).subscribe((result: any) => {
        const res = result?.result;

        if (res?.success) {
          ns.showSuccess(
            choice(res.msg, 'Dokument gelöscht')
          );
        } else {
          let errs = res?.error ? [res.error] : [
            'Fehler beim Löschen des Dokuments'
          ];
          if(Array.isArray(res?.errors)) {
            errs = res.errors;
          }
          ns.showErrors(errs);
        }
        const dialogRes: any = res || {};
        dialogRes.id = d.documentId;
        this.dialogRef.close(dialogRes);
      });
    }

    if (d.type === DeleteType.ORDER) {
      const postData = {
        op: 'deleteorder',
        order_id: this.dialogData.orderId
      };
      //orderId = this.dialogData.orderId;

      url = d.fromTrash ? '/montage/trash/orders/' : BackendPaths.ORDERS_FULL;
      //url = BackendPaths.ORDERS_FULL;// + orderId;
      const ns = this.notificationService;

      this.dataService.post(url, postData).subscribe((result: any) => {
        const res = result?.result;
        if (res.success) {
          ns.showSuccess(choice(res.msg, 'Auftrag gelöscht'));
          this.dialogRef.close(res);
        } else {
          const errors: any[] = firstNonEmpty(res.errors,
            ['Fehler beim Löschen des Auftrags']
          );
          ns.showErrors(errors);
        }
      });
    }
  }
}
